<template>
  <div>
    <v-tabs
      v-if="!isPrintScreen"
      align-with-title
    >
      <v-tab
        :to="{ name: 'General Ledger - Reconciliation Transaction' }"
      >
        Bank Reconciliation
      </v-tab>
      <v-tab
        :to="{ name: 'General Ledger - Calculate Interest' }"
      >
        Calculate Interest
      </v-tab>
      <v-tab
        :to="{ name: 'General Ledger - CREATE NEW FISCAL YEAR' }"
      >
        CREATE NEW FISCAL YEAR
      </v-tab>
      <v-tab
        :to="{ name: 'General Ledger - CHECK OD BALANCE TO GL' }"
      >
      CHECK OD BALANCE TO GL
      </v-tab>
      <v-tab
        :to="{ name: 'General Ledger - BALANCE MISC TO GL' }"
      >
      BALANCE MISC TO GL
      </v-tab>
      <v-tab
        :to="{ name: 'General Ledger - BALANCE MTG TO GL' }"
      >
      BALANCE MTG TO GL
      </v-tab>
      <v-tab
        :to="{ name: 'General Ledger - BALANCE TAX PAYMENT TO GL' }"
      >
      BALANCE TAX PAYMENT TO GL
      </v-tab>
      <v-tab
        :to="{ name: 'General Ledger - BALANCE WARRANT TO GL' }"
      >
      BALANCE WARRANT TO GL
      </v-tab>
    </v-tabs>
    <router-view />
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'GeneralLedgerUtils',
  components: {
  },
  created() {

  },
  computed: {
    ...mapState({
      isPrintScreen: (state) => state.isPrintScreen,
    }),
  },
  methods: {
  },
};
</script>
